import { useState, useRef, useEffect } from 'react';
import BookingModal from './BookingModal';

export default function CTASection() {
  const [modalOpen, setModalOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            entry.target.classList.remove('opacity-0', 'translate-y-8');
          }
        });
      },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <section className="relative w-full py-28 px-4 overflow-hidden">
        {/* Background image */}
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://storage.readdy-site.link/project_files/7ba6f116-45e4-4c55-a245-29d4f9051785/293ce59b-8e5a-428f-b0b6-831950c3222c_nsplsh_54717570474b59666c446fmv2_d_5461_3641_s_4_2-1.jpg?v=c292212b5eb37f15cf3386e702b4ec15"
            alt="sanctuary"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55" />
        </div>

        <div ref={ref} className="relative z-10 max-w-2xl mx-auto text-center opacity-0 translate-y-8 transition-all duration-1000">
          <p className="font-sans text-white/60 text-xs tracking-[0.4em] mb-8 uppercase">
            to you
          </p>

          <h2 className="font-serif text-white text-3xl md:text-4xl leading-snug mb-10">
            自分の感覚は、間違ってなかった。<br />
            <span className="text-[#B5C9B2]">そう確認しに来てください。</span>
          </h2>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-10">
            <button
              onClick={() => setModalOpen(true)}
              className="whitespace-nowrap cursor-pointer px-10 py-4 font-sans text-sm tracking-wider rounded-lg transition-all duration-300 hover:opacity-90"
              style={{ backgroundColor: '#8FA68B', color: 'white', minWidth: '220px' }}
            >
              体験セッションに申し込む
            </button>
            <a
              href="https://line.me/R/ti/p/@829esnsq?oat_content=url&ts=03251801"
              rel="nofollow noopener noreferrer"
              target="_blank"
              className="whitespace-nowrap cursor-pointer px-10 py-4 font-sans text-sm tracking-wider rounded-lg border border-white/50 text-white hover:bg-white/10 transition-all duration-300"
              style={{ minWidth: '220px', display: 'block', textAlign: 'center' }}
            >
              LINEで相談する
            </a>
          </div>

          <p className="font-sans text-white/60 text-xs leading-relaxed tracking-wide">
            迷っているなら、まだ決めなくても大丈夫です。<br />
            「行こう」と思った時が、あなたのタイミングです。
          </p>
        </div>
      </section>

      <BookingModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}
